import type { FC } from "react";
import type { ToastEntry, ToastPosition } from "@UI/types/notifications.ts";
import DToastNotificationItem from "@UI/components/Molecules/Notification/DToastNotificationItem.tsx";

interface Props {
  notifications: ToastEntry[];
  position: ToastPosition;
  onDismiss: (id: string) => void;
}

const DToastNotifications: FC<Props> = ({
  notifications,
  position,
  onDismiss,
}) => {
  return (
    <div className={`d-toast-notifications d-toast-notifications--${position}`}>
      {notifications.map(notification => (
        <DToastNotificationItem
          key={notification.id}
          entry={notification}
          onDismiss={onDismiss}
        />
      ))}
    </div>
  );
};

export default DToastNotifications;
